import { render, staticRenderFns } from "./chart-graduation.vue?vue&type=template&id=6aedc87f&scoped=true"
import script from "./chart-graduation.vue?vue&type=script&lang=js"
export * from "./chart-graduation.vue?vue&type=script&lang=js"
import style0 from "./chart-graduation.vue?vue&type=style&index=0&id=6aedc87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aedc87f",
  null
  
)

export default component.exports